// RTL language codes
export const RTL_LANGUAGES = ['he', 'ar', 'fa', 'ur', 'yi', 'dv'];

// Check if a language is RTL
export const isRTL = (language) => {
  if (!language) return false;
  return RTL_LANGUAGES.includes(language.toLowerCase());
};

// Fix punctuation placement for RTL text
export const fixRTLPunctuation = (text) => {
  if (!text) return text;
  
  // Common punctuation marks that need special handling in RTL
  const punctuationMarks = /[.,!?;:()[\]{}"'`]/g;
  
  // For RTL text, we need to ensure punctuation appears on the correct side
  // This is a simplified approach - in practice, you might want more sophisticated handling
  return text.replace(punctuationMarks, (match) => {
    // Add Unicode directional markers around punctuation
    return `\u202C${match}\u202B`;
  });
};

// Format text for RTL display with proper punctuation
export const formatRTLText = (text, language) => {
  if (!isRTL(language)) return text;
  
  // First apply RTL embedding
  let formatted = `\u202B${text}\u202C`;
  
  // Then fix punctuation placement
  formatted = fixRTLPunctuation(formatted);
  
  return formatted;
};

// Get CSS direction for a language
export const getTextDirection = (language) => {
  return isRTL(language) ? 'rtl' : 'ltr';
};

// Get CSS text alignment for a language
export const getTextAlign = (language) => {
  return isRTL(language) ? 'right' : 'left';
}; 